module.exports = __webpack_public_path__ + "static/matchday-preview-5bf92fe9a6eb5f5cfe2e4f67de00fe03.png";